import cartAPI from '../../api/cart'

const state = {
  data: {
    contribution_group_id: null,
    user_id: null,
    company_id: null,
    items: [],
    restored: false,
    monthly_story_flag: 0
  }
}
const STORAGE_KEY = 'giving-cart'
const actions = {
  restoreGivingCart ({commit}, user) {
    return new Promise((resolve, reject) => {
      if (user && user.id) { // Added new condition to not call this api when user is not login: AD - 03-04-2020
        cartAPI.getCart().then((response) => {
          let contributionGroupId = null
          if (response.length > 0) {
            commit('clear')
            commit('setUserId', user.id)
            commit('setCompanyId', user.company_id)
            response.forEach((cart) => {
              if (!contributionGroupId && cart.group_unique_id) contributionGroupId = cart.group_unique_id
              if (cart.type === 'story') {
                commit('restore', {type: cart.type, story_id: cart.story_id, project_id: cart.project_id, impact_id: cart.impact_level_id, count: cart.quantity})
              } else {
                commit('restore', {type: cart.type, project_id: cart.project_id, impact_id: cart.impact_level_id, count: cart.quantity})
              }
            })
          }
          if (contributionGroupId) {
            let givingCart = JSON.parse(localStorage.getItem(this.getters.getStorageName))
            if (givingCart !== null) {
              if (givingCart.contribution_group_id) {
                commit('setContributionGroupId', contributionGroupId)
              }
            }
          }
          commit('restored')
          resolve()
        })
      }
    })
  },
  addToGivingCart ({commit}, cart) {
    return new Promise((resolve, reject) => {
      let data = {
        op: 'add',
        user_id: cart.user_id,
        company_id: cart.company_id,
        project_id: cart.projectId,
        story_id: cart.type !== 'project' ? cart.storyId : 0,
        impact_level_id: cart.impactId,
        amt_total_usd: cart.amt_total_usd,
        quantity: cart.count,
        beneficiaries: cart.beneficiaries,
        story_group_id: cart.story_group_id,
        story_qty: (cart.count) ? cart.count : 0,
        single_contribution_total: cart.single_contribution_total,
        type: cart.type
      }
      cartAPI.updateCart(data).then((response) => {
        commit('add', cart)
        localStorage.setItem(this.getters.getStorageName, JSON.stringify(state.data))
        resolve()
      })
    })
  },
  removeProject ({commit}, item) {
    return new Promise((resolve, reject) => {
      let data = {
        op: 'remove',
        user_id: item.user_id,
        company_id: item.company_id,
        project_id: item.id,
        impact_level_id: item.impact_level_id,
        type: 'project'
      }
      cartAPI.updateCart(data).then((response) => {
        commit('remove', {project_id: item.id, type: 'project', impact_id: item.impact_level_id})
        localStorage.setItem(this.getters.getStorageName, JSON.stringify(state.data))
        resolve()
      })
    })
  },
  removeStory ({commit}, item) {
    return new Promise((resolve, reject) => {
      let data = {
        op: 'remove',
        user_id: item.user_id,
        company_id: item.company_id,
        story_id: item.id,
        impact_level_id: item.impact_level_id,
        type: 'story'
      }
      cartAPI.updateCart(data).then((response) => {
        commit('remove', {story_id: item.id, type: 'story', impact_id: item.impact_level_id})
        localStorage.setItem(this.getters.getStorageName, JSON.stringify(state.data))
        resolve()
      })
    })
  },
  update ({commit}, cart) {
    return new Promise((resolve, reject) => {
      let data = {
        op: 'update',
        user_id: cart.user_id,
        company_id: cart.company_id,
        type: cart.type,
        impact_level_id: cart.impact_id,
        quantity: cart.quantity,
        beneficiaries: cart.beneficiaries,
        project_id: cart.project_id,
        story_id: cart.type !== 'project' ? cart.story_id : 0,
        amt_total_usd: cart.amt_total_usd,
        single_contribution_total: cart.single_contribution_total,
        carts_id: cart.carts_id
      }
      cartAPI.updateCart(data).then((response) => {
        commit('update', cart)
        localStorage.setItem(this.getters.getStorageName, JSON.stringify(state.data))
        resolve(response)
      })
    })
  },
  clear ({commit}, item) {
    return new Promise((resolve, reject) => {
      let data = {
        op: 'clear',
        user_id: item.user_id,
        company_id: item.company_id,
        group_id: item.group_id ? item.group_id : null
      }
      cartAPI.updateCart(data).then((response) => {
        localStorage.removeItem(this.getters.getStorageName)
        commit('clear')
        resolve()
      })
    })
  },
  setContributionGroupId ({commit}, data) {
    return new Promise((resolve, reject) => {
      cartAPI.setContributionGroupID(data).then((response) => {
        commit('setContributionGroupId', data.group_unique_id)
        localStorage.setItem(this.getters.getStorageName, JSON.stringify(state.data))
        resolve()
      })
    })
  },
  removeContributionGroupId ({commit}, data) {
    return new Promise((resolve, reject) => {
      cartAPI.removeContributionGroupID(data).then((response) => {
        commit('removeContributionGroupId', data.group_unique_id)
        localStorage.setItem(this.getters.getStorageName, JSON.stringify(state.data))
        resolve()
      })
    })
  },
  setUserId ({commit}, id) {
    commit('setUserId', id)
  },
  setCompanyId ({commit}, id) {
    commit('setCompanyId', id)
  },
  localClear ({commit}) {
    localStorage.clear()
    commit('clear')
  }
}

const mutations = {
  restore (state, cart) {
    state.data.items.push(cart)
  },
  restored (state) {
    state.data.restored = true
  },
  setContributionGroupId (state, groupId) {
    state.data.contribution_group_id = groupId
  },
  removeContributionGroupId (state, groupId) {
    state.data.contribution_group_id = null
  },
  setUserId (state, userId) {
    state.data.user_id = userId
  },
  setCompanyId (state, companyId) {
    state.data.company_id = companyId
  },
  add (state, cart) {
    if (cart.type === 'project') {
      let found = state.data.items.find((item) => {
        if (item.type === 'project' && item.project_id === cart.projectId && item.impact_id === cart.impactId) {
          return true
        }
        return false
      })
      if (found === undefined) {
        state.data.items.push({type: 'project', project_id: cart.projectId, impact_id: cart.impactId, count: 1})
      } else {
        found.count++
      }
    } else {
      let found = state.data.items.find((item) => {
        if (item.type === 'story' && item.story_id === cart.storyId && item.impact_id === cart.impactId) {
          return true
        }
        return false
      })
      if (found === undefined) {
        state.data.items.push({
          type: 'story',
          project_id: cart.projectId,
          story_id: cart.storyId,
          impact_id: cart.impactId,
          count: cart.count
        })
      } else {
        found.count = found.count + cart.count
      }
    }
  },
  remove (state, item) {
    state.data.items = state.data.items.filter((i) => {
      if (item.type === 'project' && i.project_id === item.project_id && i.type === item.type && i.impact_id === item.impact_id) {
        return false
      }
      if (item.type === 'story' && i.story_id === item.story_id && i.type === item.type && i.impact_id === item.impact_id) {
        return false
      }
      return true
    })
  },
  update (state, item) {
    state.data.items.forEach((i) => {
      if (item.type === 'project' && i.project_id === item.project_id && i.type === item.type && i.impact_id === item.impact_id) {
        i.count = item.count
        i.impact_id = item.impact_id
      }
      if (item.type === 'story' && i.story_id === item.story_id && i.type === item.type && i.impact_id === item.impact_id) {
        i.count = item.count
        i.impact_id = item.impact_id
      }
    })
  },
  clear (state) {
    state.data.items = []
    state.data.contribution_group_id = null
    state.data.company_id = null
    state.data.user_id = null
  },
  updateMonthlyFlag (state, flag) {
    state.data.monthly_story_flag = flag
  }
}

const getters = {
  getStorageName (state) {
    let key = STORAGE_KEY + '-' + state.data.user_id
    if (state.data.company_id) {
      key += '-' + state.data.company_id
    }
    return key
  },
  getCartAnimate (state) {
    let count = 0
    state.data.items.forEach((el) => {
      count += el.count
    })
    return count
  },
  getCartCount (state) {
    return state.data.items.length
  },
  getCartItems (state) {
    return state.data.items
  },
  getCartContributionGroupId (state) {
    return state.data.contribution_group_id
  },
  getCartUserId (state) {
    return state.data.user_id
  },
  getCartCompanyId (state) {
    return state.data.company_id
  },
  getRestored (state) {
    return state.data.restored
  },
  monthlyStoryFlag (state) {
    return state.data.monthly_story_flag
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/givingCart.js